import React from "react";
import { Button } from "../../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { Contact } from "@visitproof/types";
import { useParent } from "../../../../contexts/ParentContext";
import { useDeleteAlert } from "../../../../contexts/DeleteAlertProvider";

interface DeleteContactButtonProps {
  contact: Contact;
}

const DeleteParentContactButton: React.FC<DeleteContactButtonProps> = ({
  contact,
}) => {
  const { deleteContactFromParent, setSelectedParent } = useParent();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    if (!contact.parentId) return;
    await deleteContactFromParent(contact.parentId, id);
    setSelectedParent(contact.parentId);
  };

  const handleClick = () => {
    openAlert(
      contact,
      {
        displayName: "contact",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button type="button" color={"red"} onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteParentContactButton;
